import { render, staticRenderFns } from "./SearchProjectsResults.vue?vue&type=template&id=854ae57a"
import script from "./SearchProjectsResults.vue?vue&type=script&lang=js"
export * from "./SearchProjectsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports